import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbarNotConnected26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.846c4.468 0 7.446 2.437 7.742 2.665l-1.379 1.717a2.94 2.94 0 0 0-1.44-.382 3.08 3.08 0 0 0-3.077 3.077c0 .77.283 1.465.75 2l-2.59 3.225-.006.006-.006-.012L.258 4.505C.554 4.283 3.532 1.846 8 1.846m5.508 11.108v1.17h-1.17v-1.17zm-.585-6.185c1.188 0 2.154.966 2.16 2.16 0 .474-.197.905-.505 1.213l-.48.492c-.393.388-.633.714-.633 1.52h-1.077v-.27c0-.592.24-1.133.627-1.52l.671-.678A1.1 1.1 0 0 0 14 8.923c0-.597-.48-1.077-1.077-1.077s-1.077.48-1.077 1.077H10.77c0-1.188.966-2.154 2.154-2.154"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbarNotConnected26X24Px
